module.exports = __webpack_public_path__ + "static/media/sending-emails.0080b744.svg";